module.exports = __webpack_public_path__ + "media/icons/wlasciciel-firma-blue-99973f65.png";